import { Flex } from '@teamsparta/stack-flex';
import Image from 'next/image';
import { useRouter } from 'next/router';

import type { GrassCampaignResponseDto } from '@/api/campaign/grass/grass.dto';
import Only from '@/components/common/Only';

import { getGithubDisplayMessage } from '../../logic';
import { Button } from '../../shared/Button/template';
import { Card } from '../../shared/Card/template';
import { BonusEvent } from './components/BonusEvent/template';
import { Tree } from './components/Tree/template';
import * as S from './style';

interface CampaignProps {
  grassData: GrassCampaignResponseDto;
  totalContributionData?: number;
}

export function Campaign({ grassData, totalContributionData }: CampaignProps) {
  const router = useRouter();

  const handleClickDonation = async () => {
    alert('기부 기간이 종료되었어요. 다음 이벤트를 기대해 주세요! ');
    return;
  };

  const handleClickDonationCertificate = () => {
    if (grassData?.gitHubUserId) {
      const scrollPosition = window.scrollY;
      sessionStorage.setItem('scrollPosition', scrollPosition.toString());
      router.push(`/campaign/${grassData.gitHubUserId}`);
    }
  };

  return (
    <S.Wrapper>
      <Only.Mobile>
        <Image
          src='/images/campaign/campaign_bg_tablet.png'
          alt='campaign_bg_image'
          layout='fill'
          objectFit='cover'
          sizes='100dvw'
          style={{ zIndex: '-1' }}
        />
      </Only.Mobile>
      <Only.Desktop>
        <Image
          src='/images/campaign/campaign_bg_desktop.png'
          alt='campaign_bg_image'
          layout='fill'
          objectFit='cover'
          sizes='100dvw'
          style={{ zIndex: '-1' }}
        />
      </Only.Desktop>
      <S.Container>
        <S.Title>{'잔디를 모아\n기부에 참여해 보세요'}</S.Title>
        <Card title='잔디 기부 미션' textAlign='center' titleBackground='md'>
          <S.CardTitle>
            {getGithubDisplayMessage(grassData, router.query.id)}
          </S.CardTitle>
          <Tree
            grassData={grassData}
            totalContributionData={totalContributionData || 0}
          />
          {grassData ? (
            <Flex align='start' gap='10px' style={{ width: '100%' }}>
              <S.CompleteButton disabled>참여 완료</S.CompleteButton>
              <S.CertificationButton onClick={handleClickDonationCertificate}>
                기부 증서 받기
                <Image
                  src='/images/campaign/campaign_right_arrow.svg'
                  width={20}
                  height={20}
                  alt='right_arrow'
                  style={{
                    objectFit: 'contain',
                  }}
                />
              </S.CertificationButton>
            </Flex>
          ) : (
            <div>
              <Button onClick={handleClickDonation}>
                기부 기간이 종료되었어요
              </Button>
            </div>
          )}
          <Only.Mobile>
            <Flex.Column
              align='start'
              gap='10px'
              style={{ padding: '0px 10px', width: '100%' }}
            >
              {grassData ? (
                <S.Description>
                  특별한 아이템이 담긴 나만의 기부증을 저장해 보세요.
                </S.Description>
              ) : (
                <>
                  <S.Description>
                    {
                      '* 버튼을 눌러 깃허브에 로그인하면\n자동으로 잔디(퍼블릭 컨트리뷰션) 수를 불러와요.'
                    }
                  </S.Description>
                  <S.Description>
                    {
                      '* 기부 완료 후, [기부 증서 받기] 버튼이 보이지\n 않는다면 위 [기부하기] 버튼을 한번 더 눌러주세요!'
                    }
                  </S.Description>
                </>
              )}
            </Flex.Column>
          </Only.Mobile>
          <Only.Desktop>
            <Flex.Column
              align='center'
              gap='10px'
              style={{ padding: '0px 10px', width: '100%' }}
            >
              {grassData ? (
                <S.Description>
                  특별한 아이템이 담긴 나만의 기부증을 저장해 보세요.
                </S.Description>
              ) : (
                <>
                  <S.Description>
                    {
                      '* 버튼을 눌러 깃허브에 로그인하면 자동으로\n 잔디(퍼블릭 컨트리뷰션) 수를 불러와요.'
                    }
                  </S.Description>
                  <S.Description>
                    {
                      '* 기부 완료 후, [기부 증서 받기] 버튼이 보이지\n 않는다면 위 [기부하기] 버튼을 한번 더 눌러주세요!'
                    }
                  </S.Description>
                </>
              )}
            </Flex.Column>
          </Only.Desktop>
        </Card>
        <Card title='보너스 이벤트' textAlign='left' titleBackground='md'>
          <BonusEvent />
        </Card>
      </S.Container>
    </S.Wrapper>
  );
}
